"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireWildcard(require("react"));
var _Alert = _interopRequireDefault(require("react-bootstrap/Alert"));
var _reactUseIdHook = require("react-use-id-hook");
var _DesignComponents = require("../DesignComponents/DesignComponents");
var _CompletedContext = _interopRequireDefault(require("../CompletedContext"));
var _CompletionStatusContext = _interopRequireDefault(require("../CompletionStatusContext"));
var _Storage = require("../Storage");
var _reactBootstrap = require("react-bootstrap");
require("./Navigation.css");
require("./iframeResizer.contentWindow.min.js");
var _interactiveMessenger = require("@wwnorton/interactive-messenger");
// Toggle comment on the above and below to enable/disable interactive messenger

//let InteractiveMessenger
//let MessageType
var DEBUG = false;
window.__MathJax_State__ = {
  isReady: false,
  promise: new Promise(function (resolve) {
    console.log("MathJaxCONSOLE init __MathJax_State__");
    window.MathJax = {
      // MathJax can be configured as desired in addition to these options.
      startup: {
        // Don't perform an initial typeset of the page when MathJax loads.
        // Our React components will trigger typsetting as needed.
        typeset: false,
        ready: function ready() {
          // Do whatever MathJax would normally do at this point.
          window.MathJax.startup.defaultReady();
          // Set the flag and resolve the promise.
          window.__MathJax_State__.isReady = true;
          resolve();
        }
      }
    };
  })
};
var Navigation = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Navigation, _Component);
  var _super = (0, _createSuper2.default)(Navigation);
  function Navigation(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Navigation);
    _this = _super.call(this, props);
    _this.state = {
      page: 0,
      pageCompleted: undefined,
      // Undefined: we don't know if it's true or false yet.
      completed: false,
      showNextModal: false,
      showNavButtons: undefined
    };
    _this.previousPage = _this.previousPage.bind((0, _assertThisInitialized2.default)(_this));
    _this.nextPage = _this.nextPage.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetPage = _this.resetPage.bind((0, _assertThisInitialized2.default)(_this));
    _this.collectStorage = _this.collectStorage.bind((0, _assertThisInitialized2.default)(_this));
    _this.setStorage = _this.setStorage.bind((0, _assertThisInitialized2.default)(_this));
    _this.emitMessage = _this.emitMessage.bind((0, _assertThisInitialized2.default)(_this));
    _this.queuedMessages = [];
    return _this;
  }
  (0, _createClass2.default)(Navigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (document.getElementById("mathjax-type-setter") === null) {
        var mathJaxTypeSetter = document.createElement("script");
        mathJaxTypeSetter.src = "https://cdn.jsdelivr.net/npm/mathjax@4.0.0-alpha.1/es5/tex-mml-chtml.js";
        mathJaxTypeSetter.type = "text/javascript";
        mathJaxTypeSetter.async = true;
        mathJaxTypeSetter.id = "mathjax-type-setter";
        document.body.appendChild(mathJaxTypeSetter);
      }
      window.setTimeout(function () {
        if (_this2.state.showNavButtons === undefined) {
          _this2.setState({
            showNavButtons: true
          });
        }
      }, 3000);
      if (_interactiveMessenger.InteractiveMessenger) {
        this.ims = [];
        if (this.props.interactiveId) {
          this.ims.push(new _interactiveMessenger.InteractiveMessenger(this.props.interactiveId));
        }
        if (this.props.interactiveIds) {
          var _iterator = (0, _createForOfIteratorHelper2.default)(this.props.interactiveIds),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var id = _step.value;
              this.ims.push(new _interactiveMessenger.InteractiveMessenger(id));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
      console.log("this.ims", this.ims);
      if (this.props.interactiveId || this.props.interactiveIds) {
        var _this$ims, _this$ims2;
        (_this$ims = this.ims) === null || _this$ims === void 0 ? void 0 : _this$ims.forEach(function (im) {
          return im.on(_interactiveMessenger.MessageType.Init, function (payload) {
            console.log("IM received init", payload);
            _this2.setState({
              showNavButtons: false
            });
            while (_this2.queuedMessages.length > 0) {
              var _this2$queuedMessages = _this2.queuedMessages.shift(),
                type = _this2$queuedMessages.type,
                _payload = _this2$queuedMessages.payload;
              _this2.emitMessage(type, _payload);
            }
          });
        });
        (_this$ims2 = this.ims) === null || _this$ims2 === void 0 ? void 0 : _this$ims2.forEach(function (im) {
          return im.on(_interactiveMessenger.MessageType.Navigate, function (payload) {
            console.log("IM received Navigate", payload);
            var newPage = payload.step;
            if (newPage !== _this2.state.page) {
              console.log("setState new page", newPage);
              _this2.setState({
                page: newPage
              });
              if (_this2.props.onPageChange !== undefined) {
                _this2.props.onPageChange(newPage);
              }
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant"
              });
            } else if (_this2.state.pageCompleted) {
              console.log("emitting complete again");
              var state;
              try {
                state = JSON.stringify(_this2.collectStorage());
              } catch (e) {}
              ;
              _this2.emitMessage(_interactiveMessenger.MessageType === null || _interactiveMessenger.MessageType === void 0 ? void 0 : _interactiveMessenger.MessageType.StepCompleted, {
                step: _this2.state.page,
                state: state
              });
            }
          });
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _document$getElementB, _this$ims3;
      (_document$getElementB = document.getElementById("mathjax-type-setter")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.remove();
      (_this$ims3 = this.ims) === null || _this$ims3 === void 0 ? void 0 : _this$ims3.forEach(function (im) {
        return im.destroy();
      });
    }
  }, {
    key: "setStorage",
    value: function setStorage(arr) {
      (0, _Storage.setAllStorage)(arr);
    }
  }, {
    key: "collectStorage",
    value: function collectStorage() {
      return (0, _Storage.getAllStorage)();
    }
  }, {
    key: "emitMessage",
    value: function emitMessage(type, payload) {
      if ((this.props.interactiveId || this.props.interactiveIds) && type !== undefined) {
        if (this.ims === undefined) {
          this.queuedMessages.push({
            type: type,
            payload: payload
          });
          console.log("emitMessage queued", type, payload, this.ims);
        } else {
          var _this$ims4;
          (_this$ims4 = this.ims) === null || _this$ims4 === void 0 ? void 0 : _this$ims4.forEach(function (im) {
            return im.emit(type, payload);
          });
          console.log("emitMessage", type, payload, this.ims);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      var _this$props$page;
      var page = (_this$props$page = this.props.page) !== null && _this$props$page !== void 0 ? _this$props$page : this.state.page;
      if ((page === this.props.children.length - 1 || !this.props.children.length) && this.state.pageCompleted && !this.state.completed) {
        DEBUG && console.log("Navigation componentDidUpdate completed: true", page, this.props.children.length, this.state.pageCompleted, this.state.completed);
        this.setState({
          completed: true
        });
      }
    }
  }, {
    key: "previousPage",
    value: function previousPage() {
      var _this$props$page2;
      var page = (_this$props$page2 = this.props.page) !== null && _this$props$page2 !== void 0 ? _this$props$page2 : this.state.page;
      this.setState({
        page: page - 1,
        pageCompleted: undefined
      });
      if (this.props.onPageChange !== undefined) {
        this.props.onPageChange(page - 1);
      }
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"
      });
    }
  }, {
    key: "nextPage",
    value: function nextPage() {
      if (!this.state.pageCompleted) {
        this.setState({
          showNextModal: true
        });
      } else {
        var _this$props$page3;
        var page = (_this$props$page3 = this.props.page) !== null && _this$props$page3 !== void 0 ? _this$props$page3 : this.state.page;
        this.setState({
          page: page + 1,
          pageCompleted: undefined,
          showNextModal: false
        });
        if (this.props.onPageChange !== undefined) {
          this.props.onPageChange(page + 1);
        }
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant"
        });
      }
    }
  }, {
    key: "resetPage",
    value: function resetPage() {
      (0, _Storage.clearStorage)();
      if (this.props.onReset) {
        this.props.onReset();
      }
      this.setState({
        page: 0,
        pageCompleted: undefined,
        completed: false,
        showResetModal: false
      });
      if (this.props.onPageChange !== undefined) {
        this.props.onPageChange(0);
      }
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$page4,
        _this3 = this;
      var page = (_this$props$page4 = this.props.page) !== null && _this$props$page4 !== void 0 ? _this$props$page4 : this.state.page;
      var showNext = this.state.pageCompleted && page < this.props.children.length - 1 || this.props.operableNext;
      var lastPanel = page === this.props.children.length - 1;
      if (typeof window !== "undefined") {
        var showAll = window && window.location && window.location.href && window.location.href.endsWith && window.location.href.endsWith("showAll");
      }
      var ResetButton = this.props.resetButton || function (props) {
        return page !== 0 && /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, Object.assign({
          className: "reset-button bdg-nav-button",
          variant: "outline",
          color: "tertiary"
        }, props), "Reset");
      };
      var PreviousButton = this.props.previousButton || function (props) {
        return /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, Object.assign({
          className: "prev-button bdg-nav-button",
          variant: "solid",
          color: "gray"
        }, props), "Previous");
      };
      var NextButton = this.props.nextButton || function (props) {
        return /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, Object.assign({
          className: "next-button bdg-nav-button",
          variant: "solid",
          color: "gray"
        }, props), "Next");
      };
      return /*#__PURE__*/_react.default.createElement(_CompletedContext.default.Provider, {
        value: {
          onCompleted: function onCompleted(value, id) {
            DEBUG && console.log("Navigation onCompleted", value, id);
            if (DEBUG && value === true && _this3.state.page === 1) {
              //throw new Error();
            }
            window.clearTimeout(_this3.messageDebounce);
            if (value) {
              _this3.setState({
                pageCompleted: value
              });
              var state;
              try {
                state = JSON.stringify(_this3.collectStorage());
              } catch (e) {}
              ;
              _this3.messageDebounce = window.setTimeout(function () {
                _this3.emitMessage(_interactiveMessenger.MessageType === null || _interactiveMessenger.MessageType === void 0 ? void 0 : _interactiveMessenger.MessageType.StepCompleted, {
                  step: _this3.state.page,
                  state: state
                });
              }, 100);
            } else {
              _this3.setState({
                pageCompleted: value,
                completed: false
              });
            }
            if (_this3.props.onPageCompleted) {
              _this3.props.onPageCompleted(value);
            }
          },
          registerPage: function registerPage() {
            DEBUG && console.log("Navigation registerPage");
          },
          unregisterPage: function unregisterPage() {
            DEBUG && console.log("Navigation unregisterPage");
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_reactUseIdHook.IdProvider, null, /*#__PURE__*/_react.default.createElement("main", {
        className: "navigation",
        ref: this.ref,
        "aria-live": "polite"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.props.interactiveName
      }, this.props.h1, /*#__PURE__*/_react.default.createElement(_CompletionStatusContext.default.Provider, {
        value: {
          pageCompleted: this.state.pageCompleted,
          interactiveCompleted: this.state.completed
        }
      }, this.props.children.map ? this.props.children.map(function (child, index) {
        if (index === page || showAll) {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            key: "page" + (_this3.props.sameKeys ? "" : index),
            index: index
          });
        }
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "page" + (_this3.props.sameKeys ? "" : index),
          className: "page",
          id: "page-" + index,
          role: "document"
        });
      }) : this.props.children)), this.state.showNavButtons && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonToolbar, {
        className: "justify-content-between"
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, null, /*#__PURE__*/_react.default.createElement(ResetButton, {
        key: "reset",
        group: "Reset group",
        style: page > 0 ? {} : {
          display: "none"
        },
        onClick: function onClick() {
          return _this3.setState({
            showResetModal: true
          });
        }
      }, "Reset"), ' '), /*#__PURE__*/_react.default.createElement(_reactBootstrap.ButtonGroup, null, page > 0 && /*#__PURE__*/_react.default.createElement(PreviousButton, {
        key: "prev",
        group: "Page group",
        onClick: this.previousPage
      }, "Previous"), !this.props.ghostMode && showNext && /*#__PURE__*/_react.default.createElement(NextButton, {
        key: "next",
        group: "Page group",
        onClick: this.nextPage
      }, "Next"), this.props.ghostMode && !lastPanel && /*#__PURE__*/_react.default.createElement(NextButton, {
        key: "next",
        group: "Page group",
        onClick: this.nextPage,
        disabled: !showNext
      }, "Next"))), /*#__PURE__*/_react.default.createElement(_DesignComponents.Modal, {
        hideTitle: true,
        title: "Error",
        isOpen: this.state.showNextModal,
        onRequestClose: function onRequestClose() {
          _this3.setState({
            showNextModal: false
          });
        },
        onEntering: function onEntering() {
          var body = document.querySelector("body");
          body.style.removeProperty("padding-right");
        },
        actions: [/*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
          key: "close",
          variant: "solid",
          color: "blue",
          onClick: function onClick() {
            _this3.setState({
              showNextModal: false
            });
          }
        }, "Okay")]
      }, /*#__PURE__*/_react.default.createElement("p", null, "Please complete the current page before continuing.")), /*#__PURE__*/_react.default.createElement(_DesignComponents.Modal, {
        hideTitle: true,
        title: "Reset",
        isOpen: this.state.showResetModal,
        onRequestClose: function onRequestClose() {
          _this3.setState({
            showResetModal: false
          });
        },
        onEntering: function onEntering() {
          var body = document.querySelector("body");
          body.style.removeProperty("padding-right");
        },
        actions: [/*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
          key: "close",
          variant: "solid",
          color: "blue",
          onClick: function onClick() {
            _this3.resetPage();
            _this3.setState({
              showResetModal: false
            });
          }
        }, "Reset")]
      }, /*#__PURE__*/_react.default.createElement("p", null, "Are you sure you want to reset? This will reset the entire activity.")), this.props.pageCount && /*#__PURE__*/_react.default.createElement("p", {
        style: {
          textAlign: "right"
        }
      }, "Page ", page + 1, " of ", this.props.children.length)), this.state.completed && this.state.showNavButtons && /*#__PURE__*/_react.default.createElement(_Alert.default, {
        variant: "info",
        style: {
          textAlign: "center"
        }
      }, this.props.completionText === undefined ? "Interactive complete" : this.props.completionText))));
    }
  }]);
  return Navigation;
}(_react.Component);
exports.default = Navigation;